import PropTypes from 'prop-types'
import React, { useState } from 'react'
import Button from 'components/common/Button'
import TicketCountsSelector from './TicketCountsSelector'
import styles from './rsvp-by-host-accepted.scss'
import RsvpTitle from './RsvpTitle'
import { deepCopyArray } from 'src/services/utils'

const RSVPByHostDeclinedToAccepted = ({
  event,
  displayName,
  ticketCounts,
  onConfirm
}) => {
  const [showGuestCountControlsModal, setShowGuestCountControlsModal] = useState(false)
  const [editTicketCounts, setEditTicketCounts] = useState(deepCopyArray(ticketCounts))

  const handleChangeRsvp = () => {
    if (!event.guest_count_enabled) {
      onConfirm({ rsvpState: 'accepted', ticketCounts: editTicketCounts })
      return
    }
    setShowGuestCountControlsModal(true)
  }

  const handleChangeCount = (id, count) => {
    const newCounts = editTicketCounts.map(item =>
      item.id === id ? { ...item, count } : item
    )
    setEditTicketCounts(newCounts)
  }

  const _validConfirm = () => {
    const hasValidCount = editTicketCounts.some(item =>
      (item.label === 'adult' || item.label === 'guest') && item.count > 0
    )

    return !hasValidCount
  }

  const onClickConfirm = () => {
    onConfirm({ rsvpState: 'accepted', ticketCounts: editTicketCounts })
  }

  return (
    <div className={styles['container']}>
      {!showGuestCountControlsModal && (
        <>
          <RsvpTitle
            title="No, Can’t Go"
            subTitle={event?.name}
          />

          <Button className={styles['confirm-button']} onClick={handleChangeRsvp}>
            change RSVP to yes
          </Button>
        </>
      )}
      {showGuestCountControlsModal && (
        <>
          <RsvpTitle
            title={`${displayName} is Going`}
            subTitle={
              <>
                Including {displayName},
                <br /> How many <strong>total guests</strong> are going?
              </>
            }
          />
          <TicketCountsSelector
            child_count_enabled={event.child_count_enabled}
            ticketCounts={editTicketCounts}
            onChangeCount={handleChangeCount}
          />
          <Button
            disabled={_validConfirm()}
            className={styles['confirm-button']}
            onClick={onClickConfirm}
          >
            confirm
          </Button>
        </>
      )}
    </div>
  )
}

RSVPByHostDeclinedToAccepted.propTypes = {
  event: PropTypes.object,
  ticketCounts: PropTypes.array,
  onConfirm: PropTypes.func.isRequired,
  displayName: PropTypes.string
}

export default RSVPByHostDeclinedToAccepted
